import * as React from 'react'

import {
  Button
} from '@mui/material'

import { styled } from '@mui/material/styles';

const CPageButton = styled(Button)({
  minWidth: 36,
  color: 'rgba(0,0,0,0.7)',
  marginX: '8px'
});

const CPageArrowButton = styled(Button)({
  borderRadius: 8,
  width: 96,
  border: '1px solid #f5f5f5',
  textTransform: 'none',
  color: 'rgba(0,0,0,0.7)'
});

const CActionButton = styled(Button)({
  minWidth: 24,
  color: '#C5CEE0',
  marginX: '4px',
  fontSize: 16,
  '>.MuiButton-icon': {
    margin: 0
  }
});

const CSideButton = styled(Button)({
  width: '100%',
  textAlign: 'left',
  justifyContent: 'left',
  color: 'rgba(0,0,0,0.7)',
  textTransform: 'none',
  fontSize: 16,
  borderRadius: 12,
  paddingLeft: 16,
  paddingRight: 16,
  marginBottom: 8,
  '&:hover': {
    color: '#ffffff',
    background: '#7354EF'
  },
})

export {
  CActionButton,
  CPageButton,
  CPageArrowButton,
  CSideButton
}